import { render } from "./LicensePageButtonDownload.vue?vue&type=template&id=9307072a&ts=true"
import script from "./LicensePageButtonDownload.vue?vue&type=script&lang=ts"
export * from "./LicensePageButtonDownload.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__